import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import _ from 'lodash';
import {
	createMessage,editMessage
} from '../../../../redux/actions';

import { routes } from '../../../../redux/api/routes';
let { s3BucketAPIBaseURL } = routes;

class createEditPriceExportMessage extends Component {
	constructor(props) {
        super(props);
        this.state = {
			confirmationMessage: '',
			errorMessage: '',
			messageForm: {
				params: {
					message_id: "",
					accountNumber:  this.props.state.user.selectedAccount.ACCOUNTNUMBER,
				},
				errors: {
					message_descriptionError: '',
					start_dateError: '',
					end_dateError: '',
				}
			},
			minDate: moment(),
			start_date: null,
			end_date: null,
			whichOperation: '',

			fileUploadStatusMessage: '',
			fileUploadStatus: false,
			fileUploadErrorMessage: ''
        }
    }

	componentWillMount() {
		const self = this,
			{editPriceExports } = self.props.state.homepage;
		const whichOperation = self.props.params.whichOperation;
		self.setState({
			whichOperation: whichOperation
		})
		if((whichOperation === 'edit' && !editPriceExports)) {
			browserHistory.push('/siteManagement/manageAssets');
		} else if(whichOperation === 'edit') {
			self.setState({
				whichOperation,
				messageForm: {
					...self.state.messageForm,
					params: JSON.parse(JSON.stringify(editPriceExports)),
				},
				start_date: moment(editPriceExports.start_date),
				end_date: moment(editPriceExports.end_date),
			});
		}
	}

	updateParams(formName, event) {
		const self = this;
		const name = event.target.name;
        const value = event.target.value;
		if (value.length > 100) {
			self.setState({
				[formName]: {
					...self.state[formName],
					errors: {
						...self.state[formName].errors,
						[name + 'Error']: 'error'
					}
				}
			});
			return; // Exit the function if validation fails
		}
		self.setState({
			[formName]: {
				...self.state[formName],
				params: {
					...self.state[formName].params,
					[name]: value
				},
				errors: {
					...self.state[formName].errors,
					[name + 'Error']: '' // Clear the error
				}
			}
		}, () => {
			if(self.state[formName].errors[name + 'Error']) {
				self.setState({
					[formName]: {
						...self.state[formName],
						errors: {
							...self.state[formName].errors,
							[name+'Error']: ''
						},
					},
				});
			}
		});
	}

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	handleSubmit(event) {
		const self = this;
		const { params, errors } = self.state.messageForm;
		let formError = false;
		//Reset all errors
		for(var key in errors) {
            if(!params[key.replace("Error","")]) {
                errors[key] = 'error';
                formError = true;
            } else {
				errors[key] = '';
			}
        }
		self.setState({
			params,
			errors,
			serviceCallCompleted: false
		}, () => {
			if(!formError) {
				const payload = JSON.parse(JSON.stringify(self.state.messageForm.params));
				if(self.state.whichOperation === 'create') {
					self.props.createMessage(payload, '', response => {
						if(response.status && response.responseObject) {
							self.setState({
								serviceCallCompleted: true
							});
						} else {
							browserHistory.push('/error');
						}
					});
				} else if(self.state.whichOperation === 'edit') {
				 	self.props.editMessage(payload, '', response => {
					if(response.status && response.responseObject) {
				 			self.setState({
								serviceCallCompleted: true
				 			});
				 		} else {
				 			browserHistory.push('/error');
				 		}
				 	});
				 }
			}
		});
	}

	handleChangeStartDate(date) {
	  	const self = this;
	  	self.setState({
		  	start_date: date,
			  messageForm: {
				...self.state.messageForm,
				params: {
					...self.state.messageForm.params,
			  		start_date: date && date.format('YYYY-MM-DD')
				},
				errors: {
					...self.state.messageForm.errors,
					start_dateError: ""
				}
		  	}
	  	});
	}

	handleChangeEndDate(date) {
		const self = this;
	  	self.setState({
		  	end_date: date,
			messageForm: {
				...self.state.messageForm,
				params: {
					...self.state.messageForm.params,
					end_date: date && date.format('YYYY-MM-DD')
				},
				errors: {
					...self.state.messageForm.errors,
					end_dateError: ""
				}
		  	}
	  	});
	}

    render() {
		const self = this;
		const { messageForm: { params, errors } } = self.state;
        return (
            <div>
				<div className="push">
					<h1 className="pageTitle">PRICE EXPORT MESSAGE</h1>
				</div>
				{this.state.errorMessage?<p className="red bold push">{this.state.errorMessage}</p>:null}
				{this.state.confirmationMessage?<p className="bold push">{this.state.confirmationMessage}</p>:null}
				{this.state.serviceCallCompleted && <div>
					 {this.state.whichOperation === 'create' && <p className="bold red">Message has been created successfully.</p>}
					 {this.state.whichOperation === 'edit' && <p className="bold red">Message has been updated successfully.</p>}
				</div>}
                {errors.message_descriptionError =="error" && <p className="bold red">Message limit exceeds 100 characters.</p>}
				<div className="largePush">
					<p className="bold red" id="errorMessage">{this.state.errorMessage}</p>
					<table style={{width: '100%'}} className="formTableTypeA createOrderTableA">
						<tbody>
							<tr>
								<td className="first-column">Message</td>
								<td className="middle-column">
                                <textarea  disabled={this.state.serviceCallCompleted}  className={errors.message_descriptionError} style={{ width: "30rem", height: "3rem", borderRadius: "1rem", resize: "none", padding:"10px" }}
  										defaultValue={params.message_description}  name="message_description"  onChange={this.updateParams.bind(this, 'messageForm')}/>
								</td>
							</tr>
							<tr>
								<td className="first-column">Start Date</td>
								<td className="middle-column">
									<div className={errors.start_dateError}>
										<DatePicker disabled={this.state.serviceCallCompleted} id="start_date" dateFormat="YYYY-MM-DD" minDate={self.state.minDate} placeholderText="Click to select a date" selected={self.state.start_date} onChange={this.handleChangeStartDate.bind(this)} />&nbsp;<var>(yyyy-mm-dd)</var>
									</div>
								</td>
							</tr>
							<tr>
								<td className="first-column">End Date</td>
								<td className="middle-column">
									<div className={errors.end_dateError}>
										<DatePicker disabled={this.state.serviceCallCompleted} id="end_date" dateFormat="YYYY-MM-DD" minDate={self.state.minDate} placeholderText="Click to select a date" selected={self.state.end_date} onChange={this.handleChangeEndDate.bind(this)} />&nbsp;<var>(yyyy-mm-dd)</var>
									</div>
								</td>
							</tr>
							{!this.state.serviceCallCompleted && <tr>
								<td />
								<td className="middle-column">
		                            <input type="button" onClick={this.handleSubmit.bind(this)} className="blueButton uppercase" defaultValue="Submit" />
								</td>
							</tr>}
						</tbody>
					</table>
					{this.state.serviceCallCompleted && <div>
						<p><Link to={"/siteManagement/priceExportMessage"}>Return to Previous Screen</Link></p>
						<div className="clear" />
					</div>}
					<p>
						<Link to="/siteManagement">Back to Site Management</Link>
					</p>
				</div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	createMessage: (payload, hybridQueryParams, callback) => dispatch(createMessage(payload, hybridQueryParams, callback)),
	editMessage: (payload, hybridQueryParams, callback) => dispatch(editMessage(payload, hybridQueryParams, callback)),
});

createEditPriceExportMessage = connect(mapStateToProps, mapDispatchToProps)(createEditPriceExportMessage);
export default createEditPriceExportMessage;


// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SiteManagement/PriceExportMessage/createEditPriceExportMessage.js